import api from './api';
import { ADMIN_CLIENT_CODE } from './auth.service';

/**
 * Lista clientes disponíveis para filtro (somente admin)
 */
export async function listarClientes() {
  const clientes = await api.get('/clientes');

  return (clientes || []).filter(
    (cliente) => cliente.codigo !== ADMIN_CLIENT_CODE && cliente.ativo
  );
}
